import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {StatementTrackerService} from '../../../../statement-tracker.service';
import {TrackerTabsService, TrackerTabState} from '../../../../tracker-tabs.service';
import {CreateDisclosureSharedService, DropDownType, EntityNameChange} from '../../create-disclosure-shared.service';
import {DSTSavePayload} from '../../dst-dynamic-component-resolver.service';
import {DSTConsolGroup, TemplateHeaderComponent} from '../template-header/template-header.component';
import {TemplateHeaderService} from '../template-header/template-header.service';
import {DSTEntityDetails, TemplateLeidSelectorComponent} from '../template-leid-selector/template-leid-selector.component';
import { HttpErrorResponse } from '@angular/common/http';
import {DSTFormState, StmtAttrData, StmtData} from '../../../../../shared/models/dst-form-state.model';
import {DSTSharedService} from '../../../../../shared/dst-shared.service';
import {ModalComponent} from '@appkit4/angular-components/modal';
import {stripAmountFormatting} from '../../dst-amount.util';
import {toSaveString, safeEntityId} from '../../dst-save.util';

import { safeJsonInput } from '../../../../../../shared/_utils/safe-json-input';
@Component({
    selector: 'dst-template-sec332-id189',
    templateUrl: './template-sec332-id189.component.html',
    styleUrls: ['../template-shared.scss', './template-sec332-id189.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TemplateSec332Id189Component implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);


  @ViewChild(TemplateHeaderComponent)
  private headerComponent!: TemplateHeaderComponent;

  @ViewChildren(TemplateLeidSelectorComponent)
  private leidComponents!: QueryList<TemplateLeidSelectorComponent>;

  @Output('onSave') onSave: EventEmitter<DSTSavePayload> = new EventEmitter<DSTSavePayload>();
  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  form189!: UntypedFormGroup;
  startLoader: boolean = false;
  attMap: any = {};
  statementId: string = '';
  formInvalid: boolean = true;
  selectedOption!: string;
  transferor!: DSTEntityDetails | null;
  transferee!: DSTEntityDetails | null;
  branchEntity!: DSTEntityDetails | null;
  beginDate!: Date | string;
  endDate!: Date | string;
  defaultDate: any = '';
  isSection304Related: boolean;
  showImport: boolean = false;
  showTotal: boolean = false;
  totalCalc: number = 0;
  currentLiquidation: number = 0;
  copy: any = [];
  info: string = '';
  dcnId!: number;

  importationProp: string = '';
  gainLossPropertyDesc: string = '';
  controlNum: string = 'None.';

  liquidationDate2: any = '';
  liquidationDate3: any = '';
  liquidationDate4: any = '';
  acquiredDate: any = '';
  adoptedDate: any = '';

  selectedBasis: number = -1;
  selectedBasisName: string = '';
  selectedBasisItem: any = null;

  propertyValBasisOptions: any = [{data: []}];

  currencyOptions: any = [{data: []}];
  currencyOptions2: any = [{data: []}];
  selectedCurrency: number = 0;
  selectedCurrency2: number = 0;
  selectedCurrencyItem: any = null;
  selectedCurrencyItem2: any = null;

  showDREMsg: boolean = false;
  DREMsg: string = '';
  saveJsonObject: any;
  saveParams: { [param: string]: string } = {};
  showChildDisclosureOptionModal: boolean = false;
  @ViewChild('showChildDisclosureOption') showChildDisclosureOption!: ModalComponent;

  liquidationStateOptions: any[] = [{data: []}];
  selectedLiquidationItem: any = null;

  section304ExchangeType: any[] = [{
    data: [{
      id: 0,
      text: 'cash'
    }, {
      id: 1,
      text: 'the Transferee\'s Notes'
    }]
  }];

  headerOptions: any[] = [
    {value: 0, label: '-'},
    {value: 1, label: '(A)'}
  ];
  entityNameChangeOnDate: boolean = false;
    nameChangeChecked: boolean = false;

  constructor(private UntypedFormBuilder: UntypedFormBuilder,
              private dstSharedService: DSTSharedService,
              private sharedService: CreateDisclosureSharedService,
              private headerService: TemplateHeaderService,
              private trackerTabsService: TrackerTabsService,
              private cdref: ChangeDetectorRef) {
    this.isSection304Related = false;
  }

  private _transferors!: UntypedFormArray;
  private _additionalPropsDetails!: UntypedFormArray;

  get transferors(): UntypedFormArray {
    return this._transferors;
  }

  get additionalPropsDetails(): UntypedFormArray {
    return this._additionalPropsDetails;
  }

  trackByIndex(index: number): number {
    return index;
  }

  private _liabilityDetails!: UntypedFormArray;

  get liabilityDetails(): UntypedFormArray {
    return this._liabilityDetails;
  }

  get currency1(): AbstractControl | undefined {
    return this.form189.get('propertiesDetails')?.get('currency1') as AbstractControl;
  }

  get currency2(): AbstractControl | undefined {
    return this.form189.get('propertiesDetails')?.get('currency2') as AbstractControl;
  }

  ngOnInit(): void {
    // default values for testing only
    this.beginDate = new Date(1700, 0, 1);
    this.endDate = new Date((this.sharedService.getActiveFormState()?.taxYear || 2021) + 2, 11, 31);
    // this.defaultDate = new Date(this.sharedService.getActiveFormState()?.taxYear || 2020, 0, 1);
    // this.liquidationDate2 = new Date(this.sharedService.getActiveFormState()?.taxYear || 2020, 0, 1);
    // this.liquidationDate3 = new Date(this.sharedService.getActiveFormState()?.taxYear || 2020, 0, 1);
    // this.liquidationDate4 = new Date(this.sharedService.getActiveFormState()?.taxYear || 2020, 0, 1);
    // this.acquiredDate = new Date(this.sharedService.getActiveFormState()?.taxYear || 2020, 0, 1);
    // this.adoptedDate = new Date(this.sharedService.getActiveFormState()?.taxYear || 2020, 0, 1);
    this.form189 = this.UntypedFormBuilder.group({
      header: this.UntypedFormBuilder.group({
        consolGroup: ['', Validators.required],
        options: ['']
      }),
      // transferorDetails: this.UntypedFormBuilder.group({
      //   transferee: ['', Validators.required],
      //   transferors: this.UntypedFormBuilder.array([
      //     this.UntypedFormBuilder.control('')
      //   ])
      // }),
      datesTransfer: this.UntypedFormBuilder.group({
        // default date setup here is not working in appkit date picker, use ngModel instead
        dateTransfer1: ['', Validators.required],
        dateTransfer2: [''],
        dateTransfer3: ['']
      }),
      propertiesDetails: this.UntypedFormBuilder.group({
        importationProp: [''],
        gainLossAffectedProp: [''],
        propertyValBasis: [''],
        currency1: [''],
        currency2: [''],
        additionalPropsDetails: this.UntypedFormBuilder.array([
          this.UntypedFormBuilder.group({
            description: [''],
            transferorBasis: [''],
            fairMarketVal: ['']
          })
        ]),
      }),
      privateLetterRul: this.UntypedFormBuilder.group({
        dateIssued: ['', Validators.required],
        controlNum: ['']
      }),
      liabilitiesAssumed: this.UntypedFormBuilder.group({
        dateTransfer1: [''],
        controlNum: ['']
      }),
      liquidationState: this.UntypedFormBuilder.group({
        liquidationState: [''],
        liquidationStateDate: [''],
        suppInfo: this.UntypedFormBuilder.group({
          info: ['']
        }),
        branchInfo: this.UntypedFormBuilder.group({
          branchLEID: ['']
        })
      })
    });

    this._additionalPropsDetails = this.form189.get('propertiesDetails')?.get('additionalPropsDetails') as UntypedFormArray;
    this._liabilityDetails = this.form189.get('liabilitiesAssumed')?.get('liabilityDetails') as UntypedFormArray;

    this.sharedService.getBasisDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.propertyValBasisOptions[0].data.push({
            value: element.id,
            text: element.text,
            selected: false //element.id === 3 // default to GAAP
          });
        });
        this.propertyValBasisOptions = safeJsonInput<any>(JSON.stringify(this.propertyValBasisOptions), null, 'template-sec332-id189.parse1');
        // const gaapExist: boolean = this.propertyValBasisOptions[0].data.findIndex((d: any) => d.value === 3) >= 0;
        // if (gaapExist) {
        //   this.selectedBasis = 3;
        //   this.selectedBasisName = 'GAAP';
        // }
      }, () => {

      }, () => {
        if (this.attMap['Basis']) {
          const updatedData = this.updateDropdownList(this.propertyValBasisOptions, this.attMap['Basis'][0]);
          this.propertyValBasisOptions = updatedData.dropdownData;
          this.propertyValBasisOptions = safeJsonInput<any>(JSON.stringify(this.propertyValBasisOptions), null, 'template-sec332-id189.parse2');
          this.selectedBasis = updatedData.index;
          this.selectedBasisItem = this.propertyValBasisOptions[0]?.data?.find((i: any) => i.selected) || null;
        }
      });

    this.sharedService.getCurrencyDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach((element, index) => {
          this.currencyOptions[0].data.push({
            value: element.id,
            text: element.text,
            index: index,
          });
          this.currencyOptions2[0].data.push({
            value: element.id,
            text: element.text,
            index: index,
          });
        });
        const usdIndex: number = data.findIndex((c: any) => c.id === 84);
        if (usdIndex >= 0) {
          this.currencyOptions[0].data[usdIndex].selected = true;
          this.currencyOptions2[0].data[usdIndex].selected = true;
          this.currencyOptions = safeJsonInput<any>(JSON.stringify(this.currencyOptions), null, 'template-sec332-id189.parse3');
          this.currencyOptions2 = safeJsonInput<any>(JSON.stringify(this.currencyOptions2), null, 'template-sec332-id189.parse4');
          this.selectedCurrency = this.currencyOptions[0].data[usdIndex].value;
          this.selectedCurrency2 = this.currencyOptions2[0].data[usdIndex].value;
          this.selectedCurrencyItem = this.currencyOptions[0].data[usdIndex];
          this.selectedCurrencyItem2 = this.currencyOptions2[0].data[usdIndex];
        }
      }, () => {

      }, () => {
        if (this.attMap['Currency']) {
          this.attMap['Currency'].forEach((element: any, index: number) => {
            switch (index) {
              case 0:
                let updatedData = this.updateDropdownList(this.currencyOptions, element);
                this.currencyOptions = updatedData.dropdownData;
                this.selectedCurrency = updatedData.index;
                this.selectedCurrencyItem = this.currencyOptions[0]?.data?.find((i: any) => i.selected) || null;
                break;
              case 1:
                const updatedData2 = this.updateDropdownList(this.currencyOptions2, element);
                this.currencyOptions2 = updatedData2.dropdownData;
                this.selectedCurrency2 = updatedData2.index;
                this.selectedCurrencyItem2 = this.currencyOptions2[0]?.data?.find((i: any) => i.selected) || null;
                break;
            }
          });
        }
      });

    this.sharedService.getLiquidationStateDropdown(1).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.liquidationStateOptions[0].data.push({
            value: element.id,
            text: element.text,
            label: element.text
          });
        });
        this.liquidationStateOptions = JSON.parse(JSON.stringify(this.liquidationStateOptions));
      }, () => {

      }, () => {
        this.applyLiquidationFromAttMap();
      });

    this.loadStmtData();
  }

  ngAfterViewInit(): void {
  }

  private loadStmtData(): void {
    const data = this.sharedService.getFormData(189);
    if (data) {
      this.statementId = data.isCopiedStatement ? '' : data.statementid.toString();
      this.dcnId = parseInt(data.dcnid!);
      console.log("before timeout--->" + this.defaultDate);
      setTimeout(() => {
        console.log("inside timeout--->" + this.defaultDate);
        this.leidComponents.toArray().forEach((element: TemplateLeidSelectorComponent, index: number) => {
          switch (index) {
            case 0:
              element.fillLEID(data.secondaryleid);
              console.log("filled secondary leid--->" + this.defaultDate);
              break;
            case 1:
              element.fillLEID(data.primaryleid);
              console.log("ifilled primary leid--->" + this.defaultDate);
              break;
            case 2:
              if (data.branchleid) {
                element.fillLEID(data.branchleid);
              }
              break;
          }
        });
      },1000);
      this.populateFields(data);
      console.log("populated fields--->" + this.defaultDate);

    } else if (this.sharedService.leid !== '') {
      this.statementId = (this.trackerTabsService.getActiveTrackerTab()?.getActiveFormState().statementId!).toString();
      const formId = this.sharedService.getActiveFormState().formId;
      const taxYear = (this.sharedService.getActiveFormState()?.taxYear || 2020).toString();
      const cseId = this.sharedService.getActiveFormState().cseId;

      setTimeout(() => {
        this.leidComponents.toArray()[1].fillLEID(this.sharedService.leid);
        this.sharedService.checkImportBtnRequired(this.sharedService.leid, taxYear, this.sharedService.csStatementId.toString()).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((data: boolean) => {
            console.log(data);
            this.showImport = data;
          }, () => {

          }, () => {

          });
      });

      this.startLoader = true;
      this.sharedService.getDSTTrackerRequirementData(taxYear, cseId, formId!).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: StmtData) => {
        data && this.populateFields(data);
      }, () => { this.startLoader = false; }, () => { this.startLoader = false; });
    }else{
      this.nameChangeChecked = true;
    }
  }

  /**
   * Replace the starter blank row with one group per saved description / amount.
   * clear()+push leaves the first input bound to the removed empty group, so the
   * first saved row stays blank in edit mode.
   */
  private applyAdditionalPropRows(): void {
    const descriptions: string[] = this.attMap['Desc'] || [];
    const basis: string[] = this.attMap['BasisAmt'] || [];
    const fairMarket: string[] = this.attMap['FMVAmt'] || [];
    const count = Math.max(descriptions.length, basis.length, fairMarket.length);
    if (!count) {
      return;
    }
    const rows = Array.from({length: count}, (_value, index) => this.UntypedFormBuilder.group({
      description: [descriptions[index] ?? ''],
      transferorBasis: [stripAmountFormatting(basis[index])],
      fairMarketVal: [stripAmountFormatting(fairMarket[index])]
    }));
    (this.form189.get('propertiesDetails') as UntypedFormGroup)
      .setControl('additionalPropsDetails', this.UntypedFormBuilder.array(rows));
    this._additionalPropsDetails = this.form189.get('propertiesDetails')?.get('additionalPropsDetails') as UntypedFormArray;
    // AppKit projects the input after the first write, so push the saved
    // values again once each row's field exists.
    setTimeout(() => {
      rows.forEach((group, index) => {
        const control = this.additionalPropsDetails?.at(index);
        if (!control) {
          return;
        }
        control.get('description')?.setValue(group.get('description')?.value, {emitEvent: false});
        control.get('transferorBasis')?.setValue(group.get('transferorBasis')?.value, {emitEvent: false});
        control.get('fairMarketVal')?.setValue(group.get('fairMarketVal')?.value, {emitEvent: false});
      });
      this.cdref.detectChanges();
    });
  }

  populateFields(data: StmtData): void {
    data.children?.forEach((stmt: StmtAttrData) => {
      if (this.attMap[stmt.attributeName] == undefined) {
        this.attMap[stmt.attributeName] = [];
      }

      if (stmt.attributeValue != null) {
        this.attMap[stmt.attributeName].push(stmt.attributeValue);
      }
    });
    if (this.attMap['statementOption'] && this.attMap['statementOption'][0]) {
      this.headerOptions = [
        {value: 0, label: '-'},
        {value: 1, label: '(A)', selected: this.attMap['statementOption'][0] === '(A)'}
      ];
    }

    if (this.attMap['LiquidationDate']) {
      this.attMap['LiquidationDate'].forEach((element: any, index: number) => {
        switch (index) {
          case 0:
            if (element !== '' && element !== undefined) {
              this.defaultDate = this.formatDateForSave(element);
            }
            break;

          case 1:
            if (element !== '' && element !== undefined) {
              this.liquidationDate2 = this.formatDateForSave(element);
            }
            break;

          case 2:
            if (element !== '' && element !== undefined) {
              this.liquidationDate3 = this.formatDateForSave(element);
            }
            break;
          case 3:
            if (element !== '' && element !== undefined) {
              this.liquidationDate4 = this.formatDateForSave(element);
            }
            break;
        }
      });
    }
    if (this.attMap['AcquiredDate'] && this.attMap['AcquiredDate'][0]) {
      this.acquiredDate = this.formatDateForSave(this.attMap['AcquiredDate'][0]);

    }

    if (this.attMap['AdoptedDate'] && this.attMap['AdoptedDate'][0]) {
      this.adoptedDate = this.formatDateForSave(this.attMap['AdoptedDate'][0]);
    }

    this.applyAdditionalPropRows();


    if (this.attMap['importationPropertyDesc']) {
      this.importationProp = this.normalizeStringValue(this.attMap['importationPropertyDesc'], '');
    }
    if (this.attMap['gainLossPropertyDesc']) {
      this.gainLossPropertyDesc = this.normalizeStringValue(this.attMap['gainLossPropertyDesc'], '');
    }

    if (this.attMap['stndadditionaltext']) {
      this.info = this.normalizeStringValue(this.attMap['stndadditionaltext'], '');
    }

    if (this.attMap['PLR']) {
      this.controlNum = this.normalizeStringValue(this.attMap['PLR'], 'None.');
    }
    this.applyLiquidationFromAttMap();
    this.cdref.detectChanges();
  }

  updateDropdownList(currentOptions: any, element: string) {
    const updateList: any[] = [];
    let selectedIndex = -1;
    currentOptions[0].data.forEach((el: any, index: number) => {
      const displayText = el.text ?? el.label;
      if (parseInt(element) === el.value) {
        updateList.push({
          value: el.value,
          text: displayText,
          label: displayText,
          index: index,
          selected: true,
        });
        selectedIndex = el.value;
      } else {
        updateList.push({
          value: el.value,
          text: displayText,
          label: displayText,
          index: index,
        });
      }
    });
    return {dropdownData: [{data: updateList}], index: selectedIndex};
  }

  private applyLiquidationFromAttMap(): void {
    if (!this.attMap['LiquidationStatus'] || !this.liquidationStateOptions[0]?.data?.length) {
      return;
    }
    const updatedData = this.updateDropdownList(this.liquidationStateOptions, this.attMap['LiquidationStatus'][0]);
    this.liquidationStateOptions = JSON.parse(JSON.stringify(updatedData.dropdownData));
    this.currentLiquidation = updatedData.index;
    this.selectedLiquidationItem = this.liquidationStateOptions[0]?.data?.find((i: any) => i.selected) || null;
  }

  private extractDropdownSelection(event: any): any {
    if (!event?.selected) {
      return null;
    }
    return Array.isArray(event.selected) ? event.selected[0] : event.selected;
  }

  import(): void {
    this.startLoader = true;
    this.sharedService.getImport(this.transferor?.LEID, this.sharedService.getActiveFormState()?.taxYear, this.sharedService.getTransDateStr(this.defaultDate)).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data.length) {
          this.additionalPropsDetails.clear();
          data.forEach((element: any) => {
            this.additionalPropsDetails.push(this.UntypedFormBuilder.group({
              description: [element.DESCRIPTION],
              transferorBasis: [element.AMOUNTS],
              fairMarketVal: [element.AMOUNTS]
            }));
            this.totalCalc += element.AMOUNTS;
          });
          this.showImport = false;
          this.showTotal = true;
          // this.propertyValBasisOptions[0].data[2].selected = true;

        }
        this.startLoader = false;
      }, () => {

      }, () => {

      });
  }

  total(event: any): void {
    this.additionalPropsDetails.clear();
    if (event?.checkboxState ?? event?.srcElement?.checked ?? false) {
      this.additionalPropsDetails.push(this.UntypedFormBuilder.group({
        description: ['Net Assets'],
        transferorBasis: [this.totalCalc],
        fairMarketVal: [this.totalCalc]
      }));
    } else {
      this.totalCalc = 0;
      this.import();
    }
  }

  onFormOptionChanged(selectedOptionID: number): void {
    const selected: any = this.headerOptions.find((o: any) => {
      return o.value === selectedOptionID || o.id === selectedOptionID;
    });
    this.selectedOption = selected?.label ?? selected?.text;
  }

  addTransferor(): void {
    this.transferors.push(this.UntypedFormBuilder.control(''));
  }

  removeTransferorAt(index: number): void {
    this.transferors.removeAt(index);
  }

  liquidationChange(event: any): void {
    const change = this.extractDropdownSelection(event);
    if (!change) {
      return;
    }
    this.currentLiquidation = change.value;
    this.selectedLiquidationItem = this.liquidationStateOptions[0]?.data?.find((i: any) => i.value === change.value) ?? change;
    this.acquiredDate = (this.currentLiquidation === 1 && this.adoptedDate) ? this.formatDateForSave(this.adoptedDate) : '';
    this.cdref.detectChanges();
  }

  onTransferorChanged(selectedTransferor: DSTEntityDetails | null): void {
    this.showImport = true;
    this.showTotal = false;
    this.transferor = selectedTransferor;
    this.headerComponent.loadConsolGroups(selectedTransferor?.LEID!,this.dcnId);
    if (this.transferor && this.transferee && (this.selectedBasis !== -1)) {
      this.formInvalid = false;
    }
    // check for DRE entities
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferor, this.transferee]);
    this.showDREMsg = !!this.DREMsg;
    // check for name change
    console.log("ontrasnferor changed--->" + this.defaultDate);
    if (this.defaultDate && this.transferor?.LEID) {
      this.entityNameChangeOnDate = true;
      this.startLoader = true;
      this.sharedService.checkForEntityNameChange(this.sharedService.getFormData()?.statementid.toString(),
        this.transferor.LEID,
        this.sharedService.getTransDateStr(this.defaultDate,1),
        this.sharedService.getTaxYearStr(this.sharedService.getFormData())
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]) {
          (response[0]?.LE_NAME) && (this.transferor!.ENTITY = response[0].LE_NAME); // override entity name
          //override entity type
          this.transferor!.TAXTYPECODE = response[0]?.TAXTYPECODE!;
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error.message);
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.defaultDate) {
      this.nameChangeChecked = true;

    } else {
      this.entityNameChangeOnDate = false;
    }
  }

  onTransfereeChanged(selectedTransferee: DSTEntityDetails | null): void {
    this.transferee = selectedTransferee;
    // check for DRE entities
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferee, this.transferor]);
    this.showDREMsg = !!this.DREMsg;
    // check for name change
    console.log("on transferee changed--->" + this.defaultDate);
    if (this.defaultDate && this.transferee?.LEID) {
      this.startLoader = true;
      this.entityNameChangeOnDate = true;
      this.sharedService.checkForEntityNameChange(this.sharedService.getFormData()?.statementid.toString(),
        this.transferee.LEID,
        this.sharedService.getTransDateStr(this.defaultDate,1),
        this.sharedService.getTaxYearStr(this.sharedService.getFormData())
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]) {
          (response[0]?.LE_NAME) && (this.transferee!.ENTITY = response[0].LE_NAME); // override entity name
          //override entity type
          this.transferee!.TAXTYPECODE = response[0]?.TAXTYPECODE!;
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error.message);
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.defaultDate) {
      this.nameChangeChecked = true;

    } else {
      this.entityNameChangeOnDate = false;
    }
  }

  onBranchEntityChanged(selectedBranch: DSTEntityDetails | null): void {
    this.branchEntity = selectedBranch;
  }

  addAdditionalPropDetails(): void {
    this.additionalPropsDetails.push(this.UntypedFormBuilder.group({
      description: [''],
      transferorBasis: [''],
      fairMarketVal: ['']
    }));
  }

  removeAdditionalPropDetailsAt(index: number): void {
    this.additionalPropsDetails.removeAt(index);
  }

  addLiabilityDetails(): void {
    this.liabilityDetails.push(this.UntypedFormBuilder.group({
      description: [''],
      amount: ['']
    }));
  }

  removeLiabilityDetailsAt(index: number): void {
    this.liabilityDetails.removeAt(index);
  }

  currencyOneChange(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCurrency = change?.value;
    this.selectedCurrencyItem = change;
    const sourceData = this.currencyOptions[0]?.data ?? [];
    this.currencyOptions2[0].data = safeJsonInput<any>(JSON.stringify(sourceData), null, 'template-sec332-id189.parse5');
    this.selectedCurrency2 = change?.value;
    this.selectedCurrencyItem2 = this.currencyOptions2[0]?.data?.find((i: any) => i.value === change?.value) || null;
  }

  currencyTwoChange(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCurrency2 = change?.value;
  }

  selectBasisOption(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedBasis = change?.value;
    this.selectedBasisName = change?.label ?? change?.text;
    if (this.transferor && this.transferee && (this.selectedBasis !== -1)) {
      this.formInvalid = false;
    }
  }

  OnConsolGroupChanged(consolGroup: DSTConsolGroup): void {
    this.dcnId = consolGroup.DCNID;
  }

  save(): void {
    const trackerTab: TrackerTabState | null = this.trackerTabsService.getActiveTrackerTab();
    if (!trackerTab) {
      return;
    }
    const isPlaceholderChecked: boolean = trackerTab.isPlaceholderChecked;
    if (!this.isFormValid(isPlaceholderChecked) || !this.sharedService.confirmDRE([this.transferee, this.transferor])) {
      return;
    } else {
      this.startLoader = true;
      const formState: DSTFormState = this.sharedService.getActiveFormState();
      this.saveParams = {
        'statementID': this.statementId !== '' ? this.statementId : '0',
        'taxYear': this.sharedService.getTaxYearStr(),
        'taxYearId': formState.taxYearId?.toString() ?? '',
        'dcnId': this.dcnId ? toSaveString(this.dcnId) : '',
        'returnPeriodId': formState.returnPeriodId.toString(),
        'formId': formState.formId.toString(),
        'primaryEntityId': safeEntityId(this.transferor),
        'secondaryEntityId': safeEntityId(this.transferee),
        'branchEntityId': safeEntityId(this.branchEntity),
        'comments': this.info || '',
        'csStatementId': formState.csStatementId?.toString() || '0',
        'placeHolder': isPlaceholderChecked ? '1' : '0',
        'attachmentFileName': '',
      };
      const propertyDesc = this.importationProp;
      const gainLossPropertyDesc = this.gainLossPropertyDesc;
      const desc: string[] = [];
      const basisAmt: string[] = [];
      const fairMarketVal: string[] = [];
      this.additionalPropsDetails.controls.forEach(element => {
        desc.push(element.value.description);
        basisAmt.push(element.value.transferorBasis !== null ? stripAmountFormatting(element.value.transferorBasis.toString()) : '');
        fairMarketVal.push(element.value.fairMarketVal !== null ? stripAmountFormatting(element.value.fairMarketVal.toString()) : '');
      });
      const currencies = [toSaveString(this.selectedCurrency), toSaveString(this.selectedCurrency2)];

      this.saveJsonObject = {
        'statementOption': this.selectedOption === '-' ? '' : this.selectedOption,
        'LiquidationDate': [
          this.formatDateForSave(this.defaultDate),
          this.formatDateForSave(this.liquidationDate2),
          this.formatDateForSave(this.liquidationDate3),
          this.formatDateForSave(this.liquidationDate4)
        ],
        'importationPropertyDesc': propertyDesc || '',
        'gainLossPropertyDesc': gainLossPropertyDesc || '',
        'Basis': toSaveString(this.selectedBasis),
        'Currency': currencies,
        'Desc': desc.some((value) => value !== null && value !== undefined && value !== '') ? desc : [''],
        'BasisAmt': basisAmt,
        'FMVAmt': fairMarketVal,
        'PLR': this.normalizeStringValue(this.controlNum, 'None.'),
        'AdoptedDate': this.formatDateForSave(this.adoptedDate),
        'AcquiredDate': this.formatDateForSave(this.acquiredDate),
        'LiquidationStatus': this.currentLiquidation + '',
        'stndadditionaltext': this.normalizeStringValue(this.info, '')
      };

      // save as placeholder
      if (!this.transferee) {
        this.proceedToSave(this.saveParams, this.saveJsonObject);
      } else {
        // query database if the selected entities satisfy an optional 926 disclosure requirement
        this.sharedService.checkfor332To926AutoGenStmt(this.transferor!.LEID, this.transferee!.LEID, this.sharedService.getTaxYearStr()).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((response: any) => {
            if ((trackerTab.id === StatementTrackerService.ID_CREATE_NEW) && response[0]?.IS926REQUIRED === 'YES') {
              // prompt user whether they'd wish to fill out 926
              this.showChildDisclosureAlert();
            } else {
              this.saveJsonObject.f332OutBoundTo926 = 'false';
              this.proceedToSave(this.saveParams, this.saveJsonObject);
            }
          });
      }
    }
  }

  private proceedToSave(params: { [p: string]: string }, jsonObject: object): void {
    this.sharedService.saveStatemenet(params, jsonObject).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data) {
        this.dstSharedService.showAlert('success', 'Form Save Success!');
        this.startLoader = false;
        this.sharedService.setSavedStatementId(data.statementId);
        const childStatements = data.childStatement;
        if (childStatements?.length) {
          this.sharedService.openChildStatements(childStatements, this.onSave);
        } else {
          this.sharedService.switchTemplateMode(true);
          this.onSave.emit(); // emit without payload -- only notifies tracker to refresh grid
        }
      }
    }, () => {
      this.dstSharedService.showAlert('error', 'Error!');
      this.startLoader = false;
    });
  }

  clear(): void {
    if (this.statementId !== '' && this.statementId !== '0') {
      this.sharedService.switchTemplateMode(true);
    } else {
      this.onCancel.emit();
    }
  }

  clearDate(index: number): void {
    switch (index) {
      case 1:
        this.defaultDate = null;
        this.form189.get('datesTransfer')?.get('dateTransfer1')?.setValue(null);
        this.form189.get('datesTransfer')?.get('dateTransfer1')?.markAsTouched();
        break;
      case 2:
        this.liquidationDate2 = null;
        this.form189.get('datesTransfer')?.get('dateTransfer2')?.setValue(null);
        this.form189.get('datesTransfer')?.get('dateTransfer2')?.markAsTouched();
        break;
      case 3:
        this.liquidationDate3 = null;
        this.form189.get('datesTransfer')?.get('dateTransfer3')?.setValue(null);
        this.form189.get('datesTransfer')?.get('dateTransfer3')?.markAsTouched();
        break;
      case 4:
        this.liquidationDate4 = null;
        this.form189.get('privateLetterRul')?.get('dateIssued')?.setValue(null);
        this.form189.get('privateLetterRul')?.get('dateIssued')?.markAsTouched();
        break;
      case 5:
        this.acquiredDate = null;
        this.form189.get('liquidationState')?.get('liquidationStateDate')?.setValue(null);
        this.form189.get('liquidationState')?.get('liquidationStateDate')?.markAsTouched();
        break;
      case 6:
        this.adoptedDate = null;
        this.form189.get('liabilitiesAssumed')?.get('dateTransfer1')?.setValue(null);
        this.form189.get('liabilitiesAssumed')?.get('dateTransfer1')?.markAsTouched();
        break;
      default:
        break;
    }
    console.log('🔄 First detectChanges() called for index:', index);
    this.cdref.detectChanges();
    
    // Additional clearing step to ensure ap-date-picker component updates
    setTimeout(() => {
      // 🚀 CRITICAL: Force clear date picker input fields if they still show values
      this.forceClearDatePickerInputs(index);
    }, 0);
  }

  /**
   * 🚀 CRITICAL: Force clear date picker input fields using DOM manipulation
   * This is a fallback method for stubborn date picker components
   * Differentiates between case 1 (datesTransfer.dateTransfer1) and case 6 (liabilitiesAssumed.dateTransfer1)
   */
  private forceClearDatePickerInputs(index: number): void {
    try {
      // Map index to UntypedFormGroup and formControlName to differentiate duplicate formControlNames
      const datePickerMap: { formGroupName?: string; formControlName: string }[] = [
        { formGroupName: 'datesTransfer', formControlName: 'dateTransfer1' },      // Case 1
        { formGroupName: 'datesTransfer', formControlName: 'dateTransfer2' },      // Case 2
        { formGroupName: 'datesTransfer', formControlName: 'dateTransfer3' },      // Case 3
        { formGroupName: 'privateLetterRul', formControlName: 'dateIssued' },      // Case 4
        { formGroupName: 'liquidationState', formControlName: 'liquidationStateDate' }, // Case 5
        { formGroupName: 'liabilitiesAssumed', formControlName: 'dateTransfer1' } // Case 6 (different from Case 1)
      ];
      
      const datePickerInfo = datePickerMap[index - 1];
      
      if (datePickerInfo && datePickerInfo.formControlName) {
        let datePickerElement: Element | null = null;
        
        // If UntypedFormGroup is specified, use a more specific selector to differentiate between duplicates
        if (datePickerInfo.formGroupName) {
          // Find all elements with the formControlName, then filter by parent UntypedFormGroup
          const allElements = document.querySelectorAll(`[formcontrolname="${datePickerInfo.formControlName}"]`);
          
          for (let i = 0; i < allElements.length; i++) {
            const element = allElements[i];
            // Check if the element is within the correct UntypedFormGroup by traversing up the DOM tree
            let parent: HTMLElement | null = element.parentElement;
            let levelsChecked = 0;
            const maxLevels = 10; // Prevent infinite loops
            
            while (parent && levelsChecked < maxLevels) {
              // Check for formGroupName attribute (Angular renders this)
              const formGroupAttr = parent.getAttribute('formgroupname') || 
                                   parent.getAttribute('ng-reflect-form-group-name') ||
                                   parent.getAttribute('ng-reflect-name');
              
              if (formGroupAttr === datePickerInfo.formGroupName) {
                datePickerElement = element;
                break;
              }
              
              // Also check for Angular's internal form structure
              const ngFormGroup = (parent as any).__ngContext__;
              if (ngFormGroup) {
                // Angular stores form group names in various ways, check common patterns
                const parentId = parent.id || parent.className;
                if (parentId && parentId.includes(datePickerInfo.formGroupName)) {
                  datePickerElement = element;
                  break;
                }
              }
              
              parent = parent.parentElement;
              levelsChecked++;
            }
            if (datePickerElement) break;
          }
          
          // Fallback: For duplicate formControlNames (dateTransfer1), use position-based selection
          // Case 1 is first occurrence, Case 6 is second occurrence
          if (!datePickerElement && datePickerInfo.formControlName === 'dateTransfer1') {
            if (index === 1 && allElements.length > 0) {
              // Case 1: First occurrence (datesTransfer.dateTransfer1)
              datePickerElement = allElements[0];
            } else if (index === 6 && allElements.length > 1) {
              // Case 6: Second occurrence (liabilitiesAssumed.dateTransfer1)
              datePickerElement = allElements[1];
            } else if (allElements.length === 1) {
              // If only one element exists, use it
              datePickerElement = allElements[0];
            }
          } else if (!datePickerElement && allElements.length === 1) {
            // Fallback: if only one element with this formControlName, use it
            datePickerElement = allElements[0];
          }
        } else {
          // Fallback: use simple querySelector if no UntypedFormGroup context needed
          datePickerElement = document.querySelector(`[formcontrolname="${datePickerInfo.formControlName}"]`);
        }
        
        if (datePickerElement) {
          const inputElement = datePickerElement.querySelector('input');
          if (inputElement && inputElement.value) {
            // Clear the input value and trigger change event
            inputElement.value = '';
            inputElement.dispatchEvent(new Event('input', { bubbles: true }));
            inputElement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    } catch (error) {
      console.warn('Error clearing date picker input:', error);
    }
  }

  dateChange(event: any, index: number) {
    const picked = this.dateFromPicker(event);
    switch (index) {
      case 1: {
        this.defaultDate = picked;
        const leids: string = this.sharedService.concatLEIDs([this.transferor!, this.transferee!]);
        if (!leids) {
          return;
        }
        this.startLoader = true;
        this.entityNameChangeOnDate = true;
        this.sharedService.checkForEntityNameChange(this.sharedService.getFormData()?.statementid.toString(),
          leids,
          this.sharedService.getTransDateStr(this.defaultDate, 1),
          this.sharedService.getTaxYearStr(this.sharedService.getFormData())
        ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
          if (response) {
            for (let i = 0; i < leids.split(',').length; i++) {
              this.sharedService.updateEntityName(response[i].LEID,
                response[i].LE_NAME, [this.transferor!, this.transferee!], response[i].TAXTYPECODE);
            }
          }
          this.nameChangeChecked = true;
        }, (error: HttpErrorResponse) => {
          console.log(error);
          this.dstSharedService.showAlert('error', error.message);
        }).add(() => {
          this.startLoader = false;
        });
        break;
      }
      case 2: {
        this.liquidationDate2 = picked;
        break;
      }
      case 3: {
        this.liquidationDate3 = picked;
        break;
      }
      case 4: {
        this.liquidationDate4 = picked;
        this.controlNum = '';
        break;
      }
      case 5: {
        this.acquiredDate = picked;
        break;
      }
      case 6: {
        this.adoptedDate = picked;
        break;
      }
      default: {
        break;
      }
    }
  }

  private dateFromPicker(event: any): string {
    const startDate = event?.startDate;
    const raw = startDate && typeof startDate.format === 'function'
      ? startDate.format('YYYY-MM-DD')
      : startDate;
    return String(raw ?? '').replace(/T.+/, '').substring(0, 10);
  }

  cancel(): void {

  }

  onDPOpen(): void { // styling fix for gtw-ui
    const modalEle: Element | null = document.querySelector('ngx-daterangepicker-material');
    modalEle?.classList.add('gtw-web-components');
  }

  onChangeNumber(event: any, index: number): void {
    this.additionalPropsDetails.at(index).get('fairMarketVal')?.setValue(stripAmountFormatting(event.value).replace(/[^0-9.-]/g, ''));
  }

  private normalizeStringValue(value: any, defaultValue = ''): string {
    if (value === null || value === undefined || value === '') {
      return defaultValue;
    }
    if (Array.isArray(value)) {
      return value.length ? this.normalizeStringValue(value[0], defaultValue) : defaultValue;
    }
    return value.toString();
  }

  private formatDateForSave(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    if (value instanceof Date && !isNaN(value.getTime())) {
      return this.formatDateToYMD(value);
    }
    if (value.startDate && typeof value.startDate.format === 'function') {
      return value.startDate.format('YYYY-MM-DD');
    }
    if (typeof value === 'string') {
      const normalized = value.replace(/T.+/, '').trim();
      return normalized.length >= 10 ? normalized.substring(0, 10) : normalized;
    }
    return '';
  }

  private formatDateToYMD(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  isFormValid(placeholder: boolean): boolean {
    if (placeholder) {
      if (!this.transferor) {
        this.dstSharedService.showAlert('error', 'Please specify the Transferor');
        return false;
      }
    } else {
      if (!this.transferee) {
        this.dstSharedService.showAlert('error', 'Please specify the Transferee');
        return false;
      }
      if (!this.transferor) {
        this.dstSharedService.showAlert('error', 'Please specify the Transferor');
        return false;
      }
      if (this.defaultDate == null && this.liquidationDate2 == null && this.liquidationDate3 == null) {
        this.dstSharedService.showAlert('error', 'Please specify the Transaction date');
        return false;
      }
      if (this.selectedCurrency === 0) {
        this.dstSharedService.showAlert('error', 'Please select Fair Market value Currency type');
        return false;
      }
      if (this.selectedBasis === -1) {
        this.dstSharedService.showAlert('error', 'Please select a Basis section');
        return false;
      }
      if (this.currentLiquidation === 0) {
        this.dstSharedService.showAlert('error', 'Please specify Liquidation Status');
        return false;
      }
    }

    return true;
  }

  showChildDisclosureAlert() {
    this.showChildDisclosureOptionModal = true;
    setTimeout(() => {
      this.showChildDisclosureOption.showModal('child-disclosure-option');
    });
  }

  onChildDisclosureModalClose(): void {
    this.showChildDisclosureOptionModal = false;
  }

  onProceedToChildFormOK(gen926: string) {
    this.showChildDisclosureOption.closeModalOk('child-disclosure-option');
    setTimeout(() => {
      this.showChildDisclosureOptionModal = false;
      this.saveJsonObject.f332OutBoundTo926 = gen926;
      this.proceedToSave(this.saveParams, this.saveJsonObject);
    });
  }

  setAriaLabel(item: any, contextLabel: string = 'Option'): string {
    const label = item?.text || item?.label || '-';
    return `${contextLabel} option ${label}`.trim();
  }

  onDropdownSelectItem(event: any): void {
  }

}
